import { useAtomValue } from 'jotai';

import { isUseSectionsConversionPendingAtom } from '../template-builder/atoms';
import { useExampleStreamState } from './useExampleStreamState';
import { useStructureStreamState } from './useStructureStreamState';

/**
 * True while structure/example generation is in progress, or while a
 * sections conversion (convert, flatten, restore) is still pending.
 * Flatten and restore never stream, so they would otherwise leave Share
 * and Versions clickable.
 */
export const useIsGenerating = () => {
  const { isStreaming: isStructureStreaming, isWaitingStart: isStructureWaitingStart } =
    useStructureStreamState();
  const { isStreaming: isExampleStreaming, isWaitingStart: isExampleWaitingStart } =
    useExampleStreamState();
  const isConversionPending = useAtomValue(isUseSectionsConversionPendingAtom);

  const isGenerating =
    isStructureStreaming ||
    isExampleStreaming ||
    isStructureWaitingStart ||
    isExampleWaitingStart ||
    isConversionPending;

  return { isGenerating };
};
